import type {
  Editor,
  InputDescription,
} from "@smartsuite/automation-engine-api";
import {
  TextEditorDescription_TextInputType,
  ValueDescription_T,
} from "@smartsuite/automation-engine-api";
import type { InputCandidate } from "../../../../../../../../../types/candidate";

export const createDescription = (
  input: InputCandidate,
  editor?: Editor,
): InputDescription => ({
  inputId: `${input.inputId}`,
  label: "",
  subLabel: "",
  icon: "",
  dynamic: false,
  value: {
    type: ValueDescription_T.STRING,
    multiple: false,
  },
  editor: createEditor(editor?.editor) ?? {
    editor: {
      oneofKind: "text",
      text: {
        default: "",
        type: TextEditorDescription_TextInputType.TYPE_SHORT,
      },
    },
    required: true,
    validation: { oneofKind: undefined },
  },
});

export const createEditor = (editor?: Editor["editor"]): Editor => ({
  editor: editor ?? {
    oneofKind: "text",
    text: {
      default: "",
      type: TextEditorDescription_TextInputType.TYPE_SHORT,
    },
  },
  required: true,
  validation: { oneofKind: undefined },
});
